import React from "react";
import { setPageEvent } from "@/store/features/dashboardSlice";
import { useAppDispatch } from "@/store/store";
import { toastMessage } from "@/utils/helper/myToast";
import { deleteRole } from "@/services/role.services";
import Button from "@/common/ui/Button";

const DeleteRole: React.FC<{ role: any; onClose: any }> = ({ role, onClose }) => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = React.useState(false);

  const handleDelete = async () => {
    try {
      setIsLoading(true);
      const res: any = await deleteRole({ roleId: role.roleId });
      if (res?.status === 200) {
        const { message, isError } = res.data;
        onClose({ disabledWarning: true });
        dispatch(setPageEvent({ keys: ["role-list"], type: "refresh" }));
        return toastMessage(message, isError);
      } else {
        console.log("Error", res);
        const { message, isError } = res?.response?.data || {};
        if (message) {
          return toastMessage(message, isError);
        }
        if (res.message) {
          return toastMessage(res.message, true);
        }
      }
    } catch (error) {
      console.error("Error deleting role:", error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-3 md:p-4 relative">
      <div className="px-1 pb-4">
        <span className="text-text-default font-normal !leading-normal text-13">Are you sure you want to delete {role?.roleName} role?</span>
      </div>
      <div className="flex justify-end">
        <div className="flex justify-between gap-4">
          <Button variant="outline" size="small" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="outline-danger" size="small" onClick={handleDelete} isLoading={isLoading}>
            Delete
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteRole;
